import gql from "graphql-tag";

export const ClientByBirthday = gql`
  query clientBirthdays($brokerId: String!, $token: String!) {
    ClientByBirthday(brokerId: $brokerId, token: $token) {
      today {
        scd_name,
        scd_surname,
        scd_dateOfBirth,
        scd_email,
        scd_nickName,
        scd_correspondenceFormality,
        scd_correspondenceLanguage,
        scd_phoneNumber
      }
      week {
        scd_name,
        scd_surname,
        scd_dateOfBirth,
        scd_nickName
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/views/Dashboard/queries/clientBirthdays.js